/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { ListLike } from 'src/app/app-data/interfaces/list-like';

export function isListLike<Thing>(t: any): t is ListLike<Thing> {
	return t.forEach !== undefined;
}

export function iterateStuff<Thing>(list: ListLike<Thing> | Thing, cb: (thing: Thing) => void) {
	if (isListLike<Thing>(list)) { list.forEach(cb); }
	else { cb(list); }
}